import { render } from "./Logos.vue?vue&type=template&id=5852cb99&scoped=true&lang=html"
import script from "./Logos.vue?vue&type=script&lang=js"
export * from "./Logos.vue?vue&type=script&lang=js"

import "./Logos.vue?vue&type=style&index=0&id=5852cb99&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5852cb99"]])

export default __exports__